var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { useLang } from '../hooks/use-lang';
import { classNames } from '@shapeable/utils';
import { EntityFollowControls } from './entity-follow-controls';
import { useComponentProps } from '../context/component-props-context';
import { IconTextValue } from '../elements/icon-text-value';
import { Toggle } from '../elements/toggle';
import { TagDotIconGlyph } from '@shapeable/icons';
import { useAppState } from '../hooks/use-app-state';
var cls = classNames('entity-conversation-banner');
export var CommunityRequestTypeBannerDefaultProps = {
  showActiveEntity: true,
  showFollowControls: true,
  allItemsTitle: 'All Items',
  allItemsIcon: TagDotIconGlyph,
  activeEntityVariant: 'value'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    gap: ", ";\n    border-bottom: 1px solid ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    gap: ", ";\n    border-bottom: 1px solid ", ";\n  "])), theme.UNIT(2), theme.COLOR('line-subtle')),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    border-bottom: 1px solid ", ";\n    padding: 0 ", " ", ";\n  "], ["\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    border-bottom: 1px solid ", ";\n    padding: 0 ", " ", ";\n  "])), theme.COLOR('line-subtle'), theme.UNIT(0), theme.UNIT(3))
});
var ActiveConversationEntityStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ActiveItemHeaderStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var FallbackTitleStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding: ", " 0;\n    color: ", ";\n    ", ";\n  "], ["\n    padding: ", " 0;\n    color: ", ";\n    ", ";\n  "])), theme.UNIT(3), theme.COLOR('primary'), theme.FILL('primary'))
});
var ControlsStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: ", ";\n  "])), theme.UNIT(5))
});
var FollowControlsStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var FilterToggleStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'CommunityRequestTypeBanner',
  Container: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ActiveItemHeader: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ActiveItemHeaderStyles),
  PlainTitle: styled(IconTextValue)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), FallbackTitleStyles),
  Controls: styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  FollowControls: styled(EntityFollowControls)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), FollowControlsStyles),
  FilterToggle: styled(Toggle)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), FilterToggleStyles)
};
export var CommunityRequestTypeBanner = function (props) {
  var _a;
  var componentProps = useComponentProps(My.NAME, CommunityRequestTypeBannerDefaultProps, props);
  var entity = componentProps.entity,
    className = componentProps.className,
    showActiveEntity = componentProps.showActiveEntity,
    showFollowControls = componentProps.showFollowControls,
    allItemsTitle = componentProps.allItemsTitle,
    allItemsIcon = componentProps.allItemsIcon,
    activeEntityVariant = componentProps.activeEntityVariant;
  // const definition = useEntityDefinition(entity);
  // const entityType = entityTypeNameFor(entity);
  var _b = __read(useAppState(), 2),
    appState = _b[0],
    setAppState = _b[1];
  var t = useLang();
  var handleToggleCompletedFilter = function () {
    var newFilters = __assign({}, appState);
    if (appState.isCompleted) {
      newFilters.isCompleted = false;
    } else {
      newFilters.isCompleted = true;
    }
    setAppState(newFilters);
  };
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.ActiveItemHeader, null, !!entity || !!(entity === null || entity === void 0 ? void 0 : entity.type) ? React.createElement(My.PlainTitle, {
    iconComponent: allItemsIcon
  }, t((_a = entity === null || entity === void 0 ? void 0 : entity.type) === null || _a === void 0 ? void 0 : _a.name)) : React.createElement(My.PlainTitle, {
    iconComponent: allItemsIcon,
    iconSize: 18
  }, t(allItemsTitle))), React.createElement(My.Controls, null, !!entity && showFollowControls && React.createElement(My.FollowControls, {
    entity: entity
  }), React.createElement(My.FilterToggle, {
    isOn: appState.isCompleted,
    onClick: handleToggleCompletedFilter,
    onLabel: t('UnCompleted'),
    offLabel: t('Show All')
  })));
};
CommunityRequestTypeBanner.defaultProps = CommunityRequestTypeBannerDefaultProps;
CommunityRequestTypeBanner.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;